import { Card, Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import WebService from "../../utility/WebService";
import { EyeFill, PencilFill, TrashFill } from "react-bootstrap-icons";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import CustomTableSortable from "../../components/CustomTable/CustomTableSortable";
import HelperService from "../../utility/HelperService";
import AddUser from "./AddCustomer";
import { toast } from "react-toastify";
import ViewCustomer from "./ViewCustomer";

interface PropData {
    data: UserInterface | null
}

export interface UserInterface {
    _id: number
    fullName: string;
    email: string;
    username: string;
    password: string;
    user_type: "ADMIN" | "USER";
    organization?: string;
    otp?: string | null;
    phone?: string | null;
    temp_otp?: string | null;
    image?: string | null;
    type?: string | null;
    isVerified: string; // 'Y' or 'N'
    verificationToken?: string;
    social_type?: string | null;
    socialid?: string | null;
    status: AdminUserStatusEnum;
}

export enum AdminUserStatusEnum {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    DELETED = 'DELETED'
}
export enum OrganizationType {
    ORGANIZATION = 'ORGANIZATION',
    PERSONAL = 'PERSONAL'
}

const columns = [
    {
        id: "userEmail",
        label: "User Email",
        minWidth: 170,
        sortable: true,
    },
    {
        id: "transactionDate",
        label: "Transaction Date",
        minWidth: 170,
        sortable: true,
    },
    {
        id: "transactionType",
        label: "Transaction Type",
        minWidth: 170,
        sortable: true,
    },
    {
        id: "billingName",
        label: "Billing Name",
        minWidth: 170,
        sortable: true,
    },
    {
        id: "userName",
        label: "User Name",
        minWidth: 170,
        sortable: true,
    },
    {
        id: "amount",
        label: "Amount",
        minWidth: 170,
        sortable: true,
    },
    {
        id: "paymentMethod",
        label: "Payment Method",
        minWidth: 170,
        sortable: true,
    },
     {
        id: "paymentStatus",
        label: "Payment Status",
        minWidth: 170,
        sortable: true,
    },
    // {
    //     id: "createdAt",
    //     label: "Created Date",
    //     minWidth: 170,
    //     sortable: true,
    // },
    // {
    //     id: "action",
    //     label: "Action",
    //     minWidth: 100,
    //     align: "center" as const,
    // },
];


const Transaction = (props: PropData) => {
    const [showAdminBlade, setShowAdminBlade] = useState(false);
    const [leadershipCouncils, setLeadershipCouncils] = useState([]);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [leadershipCouncilToDelete, setLeadershipCouncilToDelete] = useState<string | null>(null);
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [search, setSearch] = useState("");
    const [sortField, setSortField] = useState<string>("createdAt");
    const [sortOrder, setSortOrder] = useState<"asc" | "desc">("desc");
    const [uiSortField, setUiSortField] = useState<string>("createdAtFormatted");
    const [loading, setLoading] = useState<boolean>(false);
    const sortFieldMap: Record<string, string> = {
        createdAtFormatted: "createdAt",
        createdAt: "createdAt",
        userEmail: "userEmail",
        transactionDate: "transactionDate",
        transactionType: "transactionType",
        billingName: "billingName",
        userName: "userName",
        amount: "amount",
        paymentMethod: "paymentMethod",
        paymentStatus: "paymentStatus",
    };
    const [userObject, setUserObject] = useState<UserInterface | null>(null)
    const [showCustomerView, setShowCustomerView] = useState(false);

    console.log("propsData", props.data);

    useEffect(() => {
        getOrganizationTransactionList();
    }, [currentPage, sortField, sortOrder]);
    const getOrganizationTransactionList = (keyword: string = "") => {
        setLoading(true);
        const params = new URLSearchParams();
        params.append("page", currentPage.toString());
        params.append("limit", itemsPerPage.toString());

        // Keyword searches
        if (keyword.trim()) {
            params.append("keyword", keyword.trim());
        }

        // Sorting
        params.append("sortField", sortField);
        params.append("sortOrder", sortOrder);

        if (!props?.data?._id) {
            setLoading(false);
            return;
        }
        WebService.getAPI({
            action: `users/get-transaction-list/${props.data._id}?${params.toString()}`,
        })
            .then((res: any) => {
                const formattedRows = res?.data?.data.map((item: any) => {
                    const getAmountValue = (amount: any) => {
                        if (amount == null) return null;

                        if (typeof amount === "object" && amount.$numberDecimal) {
                            return parseFloat(amount.$numberDecimal);
                        }

                        return parseFloat(amount);
                    };

                    const totalAmount = getAmountValue(item.totalAmount);
                    return {
                        // ...item,
                        userEmail: item.user.email || "-",
                        transactionDate: HelperService.getFormatedDate(item.createdAt),
                        transactionType: item.transactionType,
                        billingName: item.transactionBillingDetail?.name || "-",
                        userName: item.user?.fullName || "-",
                        amount: totalAmount != null
                            ? `₹${totalAmount.toLocaleString("en-IN")}`
                            : "-",
                        paymentMethod: item.paymentMethod || "-",
                        paymentStatus: item.status || "-",
                        // paymentGateway: item.paymentGatewayId || "-",
                        // createdAt: HelperService.getFormatedDate(item.createdAt),
                        action: actionList(item),
                    };
                });
                setLeadershipCouncils(formattedRows);
                setTotalCount(res?.data?.pagination?.total);
            })
            .catch((err: any) => {
                console.error("Error fetching organization transactions:", err);
            })
            .finally(() => {
                setLoading(false);
            });
    };


    const handleDeleteEvent = (leadershipCouncilId: string) => {
        setLeadershipCouncilToDelete(leadershipCouncilId);
        setShowDeleteModal(true);
    };

    const actionList = (item: any) =>
    (
        <div>
            <PencilFill className="me-3 cursor-pointer" size={16}
                onClick={() => {
                    setShowAdminBlade(true);
                    setUserObject(item);
                }}
                title="Edit"
            />
            <EyeFill className="me-3 cursor-pointer" size={18}
                onClick={() => {
                    setShowCustomerView(true);
                    setUserObject(item);
                }}
                title="View"
            />
        </div>
    );
    return (
        <>
            <AddUser show={showAdminBlade}
                handleClose={() => { setShowAdminBlade(false); getOrganizationTransactionList(); setUserObject(null); }}
                data={userObject}
            />
            <ViewCustomer show={showCustomerView}
                handleClose={() => { setShowCustomerView(false); getOrganizationTransactionList(); setUserObject(null); }}
                data={userObject}
            />
            <DeleteModal
                show={showDeleteModal}
                onHide={() => setShowDeleteModal(false)}
                onDelete={() => {
                    if (leadershipCouncilToDelete) {
                        WebService.deleteAPI({
                            action: `admin-users/delete-admin-user/${leadershipCouncilToDelete}`,
                        }).then(() => {
                            setShowDeleteModal(false);
                            toast.success("Admin User deleted successfully.");
                            getOrganizationTransactionList();
                        });
                    }
                }}
                message="Are you sure you want to delete ?"
            />
            <div className="card">
                <div className="card-body">
                    <div className="row mb-3">
                        <div className="col-md-4">
                            <Form.Label className="label">Search</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="search"
                                value={search}
                                onChange={(e) => {
                                    setSearch(e.target.value);
                                    setCurrentPage(1);
                                    getOrganizationTransactionList(e.target.value);
                                }}
                            />
                        </div>
                    </div>
                    <div style={{ width: "100%",   }}>
                        <div >
                            <CustomTableSortable
                                columns={columns}
                                rows={leadershipCouncils}
                                totalCount={totalCount}
                                currentPage={currentPage}
                                pageSize={itemsPerPage}
                                onPageChange={(page) => {
                                    setCurrentPage(page);
                                }}
                                isLoading={loading}
                                sortField={uiSortField}
                                sortOrder={sortOrder}
                                onSortChange={(columnId, order) => {
                                    setUiSortField(columnId);
                                    setSortOrder(order);
                                    const apiField = sortFieldMap[columnId] || "createdAt";
                                    setSortField(apiField);
                                    setCurrentPage(1);
                                    // Fetch is driven by the useEffect (now depends on sortField/sortOrder) using fresh state.
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Transaction;
